"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLockoutState = void 0;
exports.defaultLockoutState = {
    nameLockoutTitle: 'Account Locked',
    nameLockoutCaption: 'Please contact Customer Support for re-activation',
    nameBacktoHomePage: 'Back to Home',
};
